import { Component, Vue } from 'vue-property-decorator';
import WithRender from './balancereport.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import './balancereport.css';



@WithRender
@Component({
  components: {
    Loading
  }
})
export default class balancereport extends Vue {
  isLoading = false;
  fullName='';
  balance =''

  mounted() {
    this.getReport();
  }

  getReport(): void {
    this.isLoading = true;
    _axios.get(`${config.gateway}admin/report/walletReport/getBalance`)
      .then(response => {
        this.fullName = response.data.fullName;
        this.balance = response.data.balance;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
        this.isLoading = false;
      });
  }

}
